import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

import { useForm } from '@inertiajs/vue3';
    import TaskForm from './TaskForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Company, SharedData, Task } from '@/types';
    import { Button } from '@/components/ui/button';
    import { DialogFooter, DialogClose } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';
    import { usePage } from '@inertiajs/vue3';
    import { computed, ref } from 'vue';
    import DeleteTask from './DeleteTask.vue';
    import ContinueButton from '@/components/ContinueButton.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditTask',
  props: {
    task: {}
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const isClient = computed(() => page.props.auth.user.is_client);

    const { t } = useI18n();
    const { hasPermission } = usePermissions();

    const form = useForm({
        task_id: props.task.task_id,
        company_id: props.task.company_id,
        task_title: props.task.task_title,
        task_description: props.task.task_description,
        deadline: props.task.deadline,
        weekdays: props.task.weekdaysData,
        task_status: props.task.status,
        send_notification: props.task.send_notification,
        notification_recurring_week: props.task.notification_recurring_week,
        notification_recurring_even_week: props.task.notification_recurring_even_week,
        notification_recurring_start_of_month: props.task.notification_recurring_start_of_month,
        responsible_ids: props.task.responsible_ids,
        filename: null,
    });

    const dialogFormRef = ref<InstanceType<typeof DialogForm>>();

    const handleDelete = () => {
        dialogFormRef.value?.invalidateQueryAndClose();
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    ref_key: "dialogFormRef",
    ref: dialogFormRef,
    type: "update",
    method: "post",
    form: _unref(form),
    route: _ctx.route('v2.dashboard.tasks.update', { task_id: props.task.task_id }),
    "query-key": [_unref(QueryKey).DASHBOARD_TASKS, props.task.company_id],
    title: "dashboards.tasks_add"
  }, _createSlots({
    footer: _withCtx(() => [
      _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
        default: _withCtx(() => [
          (_unref(hasPermission)(_unref(Permission).DASHBOARD_ADMIN_DELETE))
            ? (_openBlock(), _createBlock(DeleteTask, {
                key: 0,
                task: _ctx.task,
                onDeleted: handleDelete
              }, null, 8, ["task"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(DialogClose), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "outline",
                size: "sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(form).resetAndClearErrors()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('forms.cancel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(hasPermission)(_unref(Permission).DASHBOARD_UPDATE))
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 1,
                disabled: _unref(form).processing,
                loading: _unref(form).processing,
                size: "sm",
                variant: "default"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('button-text.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(TaskForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 2
  }, [
    (isClient.value)
      ? {
          name: "trigger",
          fn: _withCtx(() => [
            _createVNode(ContinueButton, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('forms.open')), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["form", "route", "query-key"]))
}
}

})